import { render, staticRenderFns } from "./StatementsReports.vue?vue&type=template&id=47f3a8cb&scoped=true&"
import script from "./StatementsReports.vue?vue&type=script&lang=js&"
export * from "./StatementsReports.vue?vue&type=script&lang=js&"
import style0 from "./StatementsReports.vue?vue&type=style&index=0&id=47f3a8cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f3a8cb",
  null
  
)

export default component.exports